import HomeClassic from "./HomeClassic";
import HomeBlue from "./HomeBlue";
import { BLUE_LIVE } from "../../lib/theme";

export default function Home() {
  return BLUE_LIVE ? <HomeBlue /> : <HomeClassic />;
}
